const DEFAULT_OVERFLOW_WITH = '...';
const MOBILE_MAX_RESOLUTION = 770;
const DESKTOP_MIN_RESOLUTION = MOBILE_MAX_RESOLUTION + 1;

export {
    DEFAULT_OVERFLOW_WITH,
    MOBILE_MAX_RESOLUTION,
    DESKTOP_MIN_RESOLUTION
};